import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
} from "@angular/core";

import { type Media } from "@hermes/api-model-editorial";
import { LOCALE } from "@hermes/core-app-core";
import { EditorialCTAResolverModule } from "@hermes/domains-edito-fragments-editorial-cta-resolver";

@Component({
    selector: "h-media-captions",
    imports: [EditorialCTAResolverModule],
    templateUrl: "./media-captions.component.html",
    styleUrls: ["./media-captions.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaCaptionsComponent {
    public locale = inject(LOCALE);
    @Input()
    public media!: Media;
}
